import React from 'react';
import PropTypes from 'prop-types';
import _sortBy from 'lodash/sortBy';
import Frame from '../Frame';
import Tray from './Tray';

const Trays = (props) => {
  const {
    header,
    data,
    className,
    onClickEdit,
    maxProducts,
  } = props;

  const maxProductsByTray = Object.values(maxProducts);
  const sortedData = _sortBy(data, (v) => v.number);
  return (
    <Frame header={header} className={className}>
      {sortedData.map((tray, index) => (
        <Tray
          key={index}
          data={tray}
          maxProducts={maxProductsByTray[index]}
          onClickEdit={onClickEdit}
        />
      ))}
    </Frame>
  );
};

Trays.propTypes = {
  className: PropTypes.string,
  onClickEdit: PropTypes.func,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  header: PropTypes.string,
  maxProducts: PropTypes.objectOf(PropTypes.string).isRequired,
};

Trays.defaultProps = {
  className: null,
  header: null,
  onClickEdit: null,
};

export default Trays;
